import cx from 'classnames'
import React from 'react'
import { noop } from 'lodash'
import useStyles from './Styles'
import SettingsIcon from '@material-ui/icons/Settings'
import { Box, Grid, List, ListItem, Popover, Typography } from '@material-ui/core'
import { IProps } from './Interface'
import { Corner } from 'components/balloon'
import { Balloon } from 'components'
import { useTheme } from '@material-ui/core/styles'
import ExitToApp from '@material-ui/icons/ExitToApp'

const ConfigButton: React.FC<IProps> = ({
  className,
  bgColor,
  corner,
  anchor,
  onPopoverClose,
  onClickSettings,
  onLogout,
  hasPendingInitiatives,
  onOpenPendingInitiatives,
  ...props
}) => {
  const theme = useTheme()
  const classes = useStyles({})

  const logout = () => {
    onLogout()
    onPopoverClose()
  }

  const settings = () => {
    onClickSettings()
    onPopoverClose()
  }

  const openInitiatives = () => {
    onOpenPendingInitiatives()
    onPopoverClose()
  }

  return (
    <>
      <Box className={cx(className, classes.root)} {...props}>
        <Balloon bgColor={bgColor ?? theme.palette.common.lightOrange} corner={corner} size={40}>
          <SettingsIcon className={classes.icon} />
        </Balloon>
      </Box>
      <Popover
        open={Boolean(anchor)}
        anchorEl={anchor}
        onClose={onPopoverClose}
        disableScrollLock
        anchorOrigin={{ vertical: 'center', horizontal: 50 }}
      >
        <List>
          {!!hasPendingInitiatives && (
            <ListItem button onClick={openInitiatives}>
              <Typography>
                <label id={'pending-initiatives-label'}>Pending initiatives</label>
              </Typography>
            </ListItem>
          )}
          <ListItem button onClick={settings}>
            <Typography>
              <label id={'settings-label'}>Settings</label>
            </Typography>
          </ListItem>
          <ListItem button onClick={logout}>
            <Grid container alignItems={'center'}>
              <ExitToApp className={classes.logoutIcon} />
              <Typography>
                <label id={'logout-label'}>Logout</label>
              </Typography>
            </Grid>
          </ListItem>
        </List>
      </Popover>
    </>
  )
}

ConfigButton.defaultProps = {
  className: '',
  corner: Corner.BottomRight,
  onPopoverClose: noop,
  onClickSettings: noop,
  onLogout: noop
}

export default ConfigButton
